$(document).on('turbolinks:load', function () {
    let hash = window.location.hash;
    if (hash) {
        let tab = new bootstrap.Tab($(hash))
        tab.show()
    }
});